import { Modal as AntdModal } from 'antd5';
import styled from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

// antd5 fixes:
//    - too much padding around modal content
//    - use white as bg color for modal content instead of light grey
//    - X close button looks wacky
export const Modal = styled(AntdModal)`
  .ant-modal-content {
    background-color: ${({ theme }) =>
      theme.themeName === Theme.Dark
        ? theme.tertiaryBackgroundColor
        : theme.secondaryBackgroundColor};
    border-radius: unset;
    color: ${({ theme }) => theme.headerColor};
    padding: unset;
  }

  .ant-modal-close-x {
    height: unset;
    width: unset;

    color: ${({ theme }) => theme.secondaryTextColor};
  }

  .ant-modal-title {
    font-weight: 500;
    color: ${({ theme }) => theme.headerColor};
  }

  .ant-modal-header {
    background-color: ${({ theme }) =>
      theme.themeName === Theme.Dark
        ? theme.tertiaryBackgroundColor
        : theme.secondaryBackgroundColor};
    border-bottom: 1px solid ${({ theme }) => theme.borderColor};
    border-radius: unset;
    padding: 16px 24px;
  }

  .ant-modal-body {
    padding: 24px;
  }

  .ant-modal-footer {
    padding: 10px 16px;

    button {
      background: ${({ theme }) => theme.buttonBackgroundColor};
      border-color: ${({ theme }) => theme.buttonBorderColor};

      &:not(.ant-btn-dangerous) {
        color: ${({ theme }) => theme.headerColor};
      }

      &:hover,
      &:focus {
        background: ${({ theme }) => theme.secondaryBackgroundColor};
      }

      &.ant-btn-primary {
        &:not(.ant-btn-background-ghost) {
          background: ${({ theme }) => theme.teal};
          border-color: ${({ theme }) => theme.teal};
          color: #ffffff;
        }

        &.ant-btn-background-ghost {
          color: ${({ theme }) => theme.teal};
        }

        &:hover {
          background: ${({ theme }) => theme.tealActive};
          border-color: ${({ theme }) => theme.tealActive};
          color: #ffffff;
        }
      }

      &[disabled],
      &[disabled]:hover,
      &.ant-btn-dangerous.ant-btn-primary[disabled],
      &.ant-btn-dangerous.ant-btn-primary[disabled]:hover {
        background: ${({ theme }) => theme.disabledBackground};
        border-color: ${({ theme }) => theme.disabledTextColor};
        color: ${({ theme }) => theme.disabledTextColor};
      }
    }
  }
`;
